import { Injectable } from '@angular/core';
import { WebsiteThemeEnum } from "@app/salon-details/models/salon-theme.enum";

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private readonly themeOptions = {
    [WebsiteThemeEnum.LightBjootifyTheme]: 'light-bjootify-theme',
    [WebsiteThemeEnum.LightBeigeTheme]: 'light-beige-theme',
    [WebsiteThemeEnum.LightBlackTheme]: 'light-black-theme',
    [WebsiteThemeEnum.LightPinkTheme]: 'light-pink-theme',
    [WebsiteThemeEnum.LightPistachioTheme]: 'light-pistachio-theme',
    [WebsiteThemeEnum.DarkBeigeTheme]: 'dark-beige-theme',
    [WebsiteThemeEnum.DarkWhiteTheme]: 'dark-white-theme',
    [WebsiteThemeEnum.PastelBjootifyTheme]: 'pastel-bjootify-theme',
    [WebsiteThemeEnum.PastelBlackTheme]: 'pastel-black-theme',
    [WebsiteThemeEnum.PastelBeigeTheme]: 'pastel-beige-theme',
    [WebsiteThemeEnum.PastelMaroonTheme]: 'pastel-maroon-theme',
  }

  private readonly themeAttributeKey = 'data-bs-theme';

  useCustomTheme(themeOptionKey: WebsiteThemeEnum): void {
    document.documentElement.setAttribute(this.themeAttributeKey, this.themeOptions[themeOptionKey]);
  }

  useDefaultTheme() {
    document.documentElement.setAttribute(this.themeAttributeKey, this.themeOptions[WebsiteThemeEnum.LightBjootifyTheme]);
  }
}
